import { render, staticRenderFns } from "./IconExclamationSign.vue?vue&type=template&id=10149e6c&"
import script from "./IconExclamationSign.vue?vue&type=script&lang=js&"
export * from "./IconExclamationSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports